@import (reference) '../../../../../constants/spacing.module.less';

.rma-input-container {
  display: flex;
  flex-flow: column nowrap;
  gap: @space-8;
}

.checkbox-label {
  font-size: 14px;
  line-height: 16px;
}
